export default __webpack_public_path__ + "static/home-bmw-3dbab820e368e71ba1bbc4653e24ea24.gif";